import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Afficher le bouton après avoir scrollé de 400px
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Scroll smooth vers le haut
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          style={{
            position: 'fixed',
            bottom: '2rem',
            right: '2rem',
            width: '3.5rem',
            height: '3.5rem',
            borderRadius: '50%',
            background: 'var(--accent-primary)',
            color: 'white',
            border: 'none',
            boxShadow: '0 4px 20px rgba(61, 84, 70, 0.3)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
            zIndex: 1000,
            animation: 'fadeInUp 0.3s ease'
          }}
          className="scroll-to-top-button"
          aria-label="Retour en haut"
        >
          <ArrowUp size={24} strokeWidth={2.5} />
        </button>
      )}

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .scroll-to-top-button:hover {
          background: #5c9f82 !important;
          transform: translateY(-4px) !important;
          box-shadow: 0 6px 25px rgba(61, 84, 70, 0.4) !important;
        }

        .scroll-to-top-button:active {
          transform: translateY(-2px) !important;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .scroll-to-top-button {
            bottom: 1.5rem !important;
            right: 1.5rem !important;
            width: 3rem !important;
            height: 3rem !important;
          }
        }

        /* Smooth scroll global */
        html {
          scroll-behavior: smooth;
        }
      `}</style>
    </>
  );
};

export default ScrollToTop;
